/**
 * Check if a given object implements the CreatePermitResponse interface.
 */
export function instanceOfCreatePermitResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
export function CreatePermitResponseFromJSON(json) {
    return CreatePermitResponseFromJSONTyped(json, false);
}
export function CreatePermitResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
export function CreatePermitResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
